/* Excella Automotive — Scroll behaviors v1
   - Adds body.excella-scrolled when window.scrollY > 80 (header dense mode)
   - Lazy-loads off-screen images in product grids
*/
(function () {
  'use strict';

  /* ── Header scroll class ── */
  var THRESHOLD = 80;
  var ticking = false;

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        if (window.scrollY > THRESHOLD) {
          document.body.classList.add('excella-scrolled');
        } else {
          document.body.classList.remove('excella-scrolled');
        }
        ticking = false;
      });
      ticking = true;
    }
  }

  // Set initial state immediately (handles page load at scroll position)
  if (window.scrollY > THRESHOLD) document.body.classList.add('excella-scrolled');

  window.addEventListener('scroll', onScroll, { passive: true });

  /* ── Smooth anchor scroll ── */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();

/* ── YouTube thumbnail lazy-loader (moved from theme.liquid inline script) ── */
document.addEventListener('DOMContentLoaded', function () {
  var v = document.getElementsByClassName('youtube-player');
  for (var n = 0; n < v.length; n++) {
    (function (el) {
      var div = document.createElement('div');
      div.setAttribute('data-id', el.dataset.id);
      div.innerHTML = '<img src="https://i.ytimg.com/vi/' + el.dataset.id + '/hqdefault.jpg"><div class="play"></div>';
      div.onclick = function () {
        var iframe = document.createElement('iframe');
        iframe.setAttribute('src', 'https://www.youtube.com/embed/' + this.dataset.id + '?autoplay=1');
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '1');
        this.parentNode.replaceChild(iframe, this);
      };
      el.appendChild(div);
    })(v[n]);
  }
});

/* ── Recently-viewed section cleanup (moved from theme.liquid inline script) ── */
$(document).ready(function () {
  setTimeout(function () {
    if ($('#recently-viewed-container #recently-viewed-products .owl-item').length < 1) {
      $('#recently-viewed-container').remove();
      $('.recently--viewed-hr').remove();
    }
  }, 5000);
});

/* ── Hide pointless single-variant "Default Title" selectors (e.g. in Quick Buy) ──
   When a product has only one variant, Shopify names it "Default Title". The variant
   <select> then shows "Default Title - $price", which confuses customers. Hide the
   select in that case — its value still submits, so Add to Cart keeps working. */
(function () {
  function hideDefaultTitleSelects(root) {
    var sels = (root || document).querySelectorAll('select.product-single__variants');
    for (var i = 0; i < sels.length; i++) {
      var sel = sels[i];
      if (sel.options.length === 1 && /default title/i.test(sel.options[0].text)) {
        sel.style.display = 'none';
      }
    }
  }
  if (window.MutationObserver) {
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1 && (node.querySelector ?
              (node.matches && node.matches('.quickview-form') ? true : node.querySelector('select.product-single__variants')) : false)) {
            hideDefaultTitleSelects(document);
          }
        }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('DOMContentLoaded', function () { hideDefaultTitleSelects(document); });
})();
